
import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { allProducts } from '../../mocks/products';

export default function ProductDetail() {
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);
  const [showAddedMessage, setShowAddedMessage] = useState(false);

  const product = allProducts.find(p => p.id === Number(id));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!product) {
    return (
      <div className="min-h-screen" style={{ backgroundColor: '#0D1B2A' }}>
        <Navbar />
        <div className="pt-32 pb-20 text-center">
          <h1 className="text-3xl font-bold mb-4 text-white">المنتج غير موجود</h1>
          <Link to="/products" className="cursor-pointer" style={{ color: '#D4A84B' }}>
            العودة للمنتجات
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const images = [product.image, product.image, product.image];
  const relatedProducts = allProducts.filter(p => p.category === product.category && p.id !== product.id).slice(0, 4);

  const handleAddToCart = () => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    const existingItem = cart.find((item: any) => item.id === product.id);

    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        quantity: quantity
      });
    }

    localStorage.setItem('cart', JSON.stringify(cart));
    setShowAddedMessage(true);
    setTimeout(() => setShowAddedMessage(false), 3000);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0D1B2A' }}>
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center gap-2 text-sm mb-8 text-gray-400">
            <Link to="/" className="hover:text-[#D4A84B] cursor-pointer">الرئيسية</Link>
            <span>/</span>
            <Link to="/products" className="hover:text-[#D4A84B] cursor-pointer">المنتجات</Link>
            <span>/</span>
            <span className="text-white">{product.name}</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
            <div>
              <div className="rounded-2xl overflow-hidden mb-4 w-full h-[500px]" style={{ backgroundColor: '#1B2D3E' }}>
                <img 
                  src={images[selectedImage]}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-3 gap-4">
                {images.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setSelectedImage(idx)}
                    className={`rounded-lg overflow-hidden border-2 transition-all cursor-pointer w-full h-32`}
                    style={{ 
                      backgroundColor: '#1B2D3E',
                      borderColor: selectedImage === idx ? '#D4A84B' : 'transparent'
                    }}
                  >
                    <img 
                      src={img}
                      alt={`${product.name} ${idx + 1}`}
                      className="w-full h-full object-cover object-top"
                    />
                  </button>
                ))}
              </div>
            </div>

            <div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                {product.name}
              </h1>

              <div className="flex items-center gap-4 mb-6">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-5 h-5 flex items-center justify-center">
                      <i className={`ri-star-${i < product.rating ? 'fill' : 'line'} text-lg`} style={{ color: '#D4A84B' }}></i>
                    </div>
                  ))}
                </div>
                <span className="text-gray-400">({product.reviews} تقييم)</span>
              </div>

              <div className="flex items-center gap-4 mb-8">
                <span className="text-4xl font-bold" style={{ color: '#D4A84B' }}>
                  {product.price} ر.س
                </span>
                {product.originalPrice && (
                  <>
                    <span className="text-2xl line-through text-gray-500">
                      {product.originalPrice} ر.س
                    </span>
                    <span className="text-black px-3 py-1 rounded-full text-sm font-bold" style={{ backgroundColor: '#D4A84B' }}>
                      خصم {product.discount}%
                    </span>
                  </>
                )}
              </div>

              <div className="rounded-xl p-6 mb-8" style={{ backgroundColor: '#1B2D3E' }}>
                <h3 className="text-lg font-bold mb-3 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                  وصف المنتج
                </h3>
                <p className="leading-relaxed text-gray-400">
                  منتج عالي الجودة مصنوع من أفضل المواد. يتميز بالمتانة والأداء الممتاز. مناسب للاستخدام اليومي ويأتي مع ضمان الجودة. تصميم عصري وأنيق يناسب جميع الأذواق. سهل الاستخدام ومريح للغاية.
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-lg font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                  الكمية
                </h3>
                <div className="flex items-center gap-4">
                  <div className="flex items-center border-2 rounded-lg" style={{ borderColor: '#2D4356' }}>
                    <button
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="px-4 py-3 hover:bg-[#1B2D3E] transition-colors cursor-pointer text-white"
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-subtract-line text-xl"></i>
                      </div>
                    </button>
                    <span className="px-6 py-3 text-lg font-bold min-w-[60px] text-center text-white">
                      {quantity}
                    </span>
                    <button
                      onClick={() => setQuantity(quantity + 1)}
                      className="px-4 py-3 hover:bg-[#1B2D3E] transition-colors cursor-pointer text-white"
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-add-line text-xl"></i>
                      </div>
                    </button>
                  </div>
                </div>
              </div>

              <button
                onClick={handleAddToCart}
                className="w-full text-black text-lg font-bold py-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#D4A84B' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#E5B95C'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#D4A84B'}
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-shopping-cart-line text-2xl"></i>
                </div>
                أضف إلى السلة
              </button>

              {showAddedMessage && (
                <div className="mt-4 bg-green-900/50 border-2 border-green-500 text-green-400 px-6 py-4 rounded-lg flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-2xl"></i>
                  </div>
                  <span className="font-bold">تمت الإضافة إلى السلة بنجاح!</span>
                </div>
              )}

              <div className="grid grid-cols-3 gap-4 mt-8">
                <div className="text-center p-4 rounded-lg" style={{ backgroundColor: '#1B2D3E' }}>
                  <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-truck-line text-3xl" style={{ color: '#D4A84B' }}></i>
                  </div>
                  <p className="text-sm font-semibold text-white">شحن مجاني</p>
                </div>
                <div className="text-center p-4 rounded-lg" style={{ backgroundColor: '#1B2D3E' }}>
                  <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-shield-check-line text-3xl" style={{ color: '#D4A84B' }}></i>
                  </div>
                  <p className="text-sm font-semibold text-white">ضمان الجودة</p>
                </div>
                <div className="text-center p-4 rounded-lg" style={{ backgroundColor: '#1B2D3E' }}>
                  <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                    <i className="ri-arrow-go-back-line text-3xl" style={{ color: '#D4A84B' }}></i>
                  </div>
                  <p className="text-sm font-semibold text-white">إرجاع سهل</p>
                </div>
              </div>
            </div>
          </div>

          {relatedProducts.length > 0 && (
            <div>
              <h2 className="text-3xl font-bold mb-8 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                منتجات ذات صلة
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {relatedProducts.map((relatedProduct) => (
                  <Link
                    key={relatedProduct.id}
                    to={`/product/${relatedProduct.id}`}
                    className="group cursor-pointer"
                  >
                    <div className="rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" style={{ backgroundColor: '#1B2D3E' }}>
                      <div className="relative aspect-square w-full h-full overflow-hidden" style={{ backgroundColor: '#0D1B2A' }}>
                        <img 
                          src={relatedProduct.image}
                          alt={relatedProduct.name}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6">
                        <h3 className="text-lg font-bold mb-2 line-clamp-2 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                          {relatedProduct.name}
                        </h3>
                        <div className="flex items-center gap-3">
                          <span className="text-2xl font-bold" style={{ color: '#D4A84B' }}>
                            {relatedProduct.price} ر.س
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
